<template>
  <setting-message-template-form
    @submit="register"
  />
</template>

<script>
import SettingMessageTemplateForm from '@/components/organisms/SettingMessageTemplateForm'
import Indicator from '@/lib/indicator'

export default {
  components: { SettingMessageTemplateForm },
  methods: {
    register (name, subject, body) {
      const params = { name, subject, body }
      Indicator.emitShow()
      this.$http.secured.post('/company/entry/message/templates', params)
        .then(response => {
          this.$router.push({ name: 'settingMessageTemplates' })
        }).finally(() => {
          Indicator.emitHide()
        })
    }
  }
}
</script>
